export default __webpack_public_path__ + "static/media/AkshayUnnikrishnan_headshot.3b4a6a1e.png";